import React from 'react';
import { Link } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import useTelemetry from '@monorepo/shared/src/hooks/use-telemetry';
import {
  ApplicationSection,
  ApplicationTab,
} from '@monorepo/shared/src/graph/schema-generated-types-educator';
import { TelemetryEvents } from '@monorepo/shared/src/types';
import TabHeading from 'components/common/TabHeading';

const t = (key: string, options?) => translate('classroomBooks', key, options);

type Props = {
  isSelected?: boolean;
  fromRoute?: string;
};

const ClassroomBooksTabHeading: React.FC<Props> = ({ isSelected }) => {
  const [, { fireEvent }] = useTelemetry(TelemetryEvents.VIEW_TAB);
  const classes = useStyles({ isSelected });

  const createTelemetryEvent = () => {
    fireEvent({
      section: ApplicationSection.LETTER_BOOKS,
      tab: ApplicationTab.GREAT_ALPHABET_PARADE,
    });
  };

  return (
    <TabHeading>
      <Link to="/classroom-books" className={classes.link} onClick={createTelemetryEvent}>
        <h2 className={classes.h2}>{t('greatAlphabetParade')}</h2>
      </Link>
    </TabHeading>
  );
};

const useStyles = makeStyles((theme: any) => ({
  h2: {
    color: ({ isSelected }: Props) =>
      isSelected ? theme.palette.black.main : theme.palette.grey[600],
    margin: '0px',
  },
  link: { height: '60px', lineHeight: '60px', width: '100%' },
}));

export default ClassroomBooksTabHeading;
